import React from 'react';
import { LinkIconButton } from '@atlaskit/button/new';
import LogInIcon from '@atlaskit/icon/core/log-in';
import { useIntl as useIntlDI } from '@atlassian/jira-intl';
import { useIsAnonymous as useIsAnonymousDI } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { NAVIGATION_ITEM_ID } from '../../common/constants.tsx';
import { TopLevelErrorBoundary } from '../../common/ui/error-boundary/index.tsx';
import { useNavigationItemAnalytics as useNavigationItemAnalyticsDI } from '../../controllers/navigation-item-analytics/main.tsx';
import messages from './messages.tsx';
import type { SignInProps } from './types.tsx';
import { useDestinationParam as useDestinationParamDI } from './utils.tsx';

const SignIn = ({
	// eslint-disable-next-line react-hooks/react-compiler
	useDestinationParam = useDestinationParamDI,
	// eslint-disable-next-line react-hooks/react-compiler
	useIntl = useIntlDI,
	// eslint-disable-next-line react-hooks/react-compiler
	useNavigationItemAnalytics = useNavigationItemAnalyticsDI,
	// eslint-disable-next-line react-hooks/react-compiler
	useIsAnonymous = useIsAnonymousDI,
}: SignInProps) => {
	// eslint-disable-next-line react-hooks/react-compiler
	const destinationParam = useDestinationParam();
	// eslint-disable-next-line react-hooks/react-compiler
	const isAnonymous = useIsAnonymous();
	// eslint-disable-next-line react-hooks/react-compiler
	const { formatMessage } = useIntl();
	// eslint-disable-next-line react-hooks/react-compiler
	const triggerAnalytics = useNavigationItemAnalytics({
		navigationItemId: NAVIGATION_ITEM_ID.SIGN_IN,
	});

	if (!isAnonymous) return null;

	return (
		<LinkIconButton
			href={`/login.jsp?${destinationParam}`}
			icon={LogInIcon}
			label={formatMessage(messages.signIn)}
			isTooltipDisabled={false}
			appearance="subtle"
			// @ts-expect-error - TS2769 - No overload matches this call.
			onClick={triggerAnalytics}
		/>
	);
};

const SignInWithErrorBoundary = (props: SignInProps): React.JSX.Element => (
	<TopLevelErrorBoundary id={NAVIGATION_ITEM_ID.SIGN_IN}>
		<SignIn {...props} />
	</TopLevelErrorBoundary>
);

export { SignInWithErrorBoundary as SignIn };
